import {
  CheckoutAbTestMetricToOptimize,
  CheckoutAbTestTreatmentSchema,
} from "@redotech/redo-model/checkouts/checkout-ab-test-builder";
import * as z from "zod/v4";

export const createCheckoutSplitFromBuilder = {
  name: "createCheckoutSplitFromBuilder" as const,
  input: z.object({
    testName: z.string(),
    testHypothesis: z.string(),
    metricToOptimize: z.enum(CheckoutAbTestMetricToOptimize),
    controlTreatment: CheckoutAbTestTreatmentSchema,
    variantTreatments: z.array(CheckoutAbTestTreatmentSchema),
    enableSplit: z.boolean(),
  }),
  output: z.null(),
};
